<template>

  <StandardTemplate>
    <div class="flex flex-row mb-4 mt-6 items-center">
      <h4 class="text-gray-500">
        Settings
      </h4>
      <i class="arrow-forward material-icons text-black">
        chevron_right
      </i>
      <h4 class="text-gray-800">
        Default Template Values
      </h4></div>
    <div class="flex flex-row justify-start">
      <!--      <settings-nav :settings-page="'Templates'" class="xs:hidden sm:block" />-->

      <div class="bg-white rounded-md pr-4">
        <h5 class="mt-4 ml-6 font-bold">
          Auto SOAP Template
        </h5>
        <p class="text-gray-500 text-xs ml-6 mt-2 mr-4">
          Personalize the way Talkatoo will report for each item when not mentioned within the exam.
        </p>
        <div class="border-2 border-rare-alt rounded-sm mt-3 ml-2 mr-2 bg-pastel-purple-lighter w-full">
          <div class="bg-rare-alt h-9 text-white pl-8 justify-items-center pt-2 font-bold">
            Subjective
          </div>
          <div class="h-auto py-4 pl-8 font-normal">
            No Default Fields to Edit
          </div>
        </div>
        <div v-if="settings" class="border-2 border-main-alt rounded-sm mt-3 ml-2 mr-2 mb-2 bg-pastel-blue-lighter w-full">
          <div class="bg-main-alt h-9 text-white pl-8 justify-items-center pt-2 font-bold mb-2">
            Objective
          </div>
          <div v-for="each in settings" :key="each?.subsection" class="group bg-white hover:bg-gray-100 rounded-sm py-2 h-auto my-[2px] items-center mx-2
          grid xs:grid-rows:2 sm:grid-rows:1 xs:grid-cols-[45%_10%_45%] sm:grid-cols-[30%_45%_25%]
           justify-self-center">
            <div class="text-gray-700 ml-3 xs:mb-2 sm:mb-0">
              {{ each?.subsection }}:
            </div>
            <input :id="`${each?.subsection}-input`" v-model="each.value" class="my-0.5 border-[1px] border-gray-500 font-roboto rounded-sm max-w-xs focus:border-main-alt xs:mx-3 pl-3
            xs:row-start-2 xs:col-start-1 xs:col-end-4 sm:row-start-1 sm:col-start-2 sm:col-end-3
             flex-none h-9" @blur="(e) => saveValue(e, each)" @focusin="(e) => inputFocused(e, each)" />

            <div class="items-center flex justify-end pl-2  xs:col-start-3 xs:col-end-3 ">
              <img :id="`${each?.subsection}-undo`"
                   class="undo-item opacity-40 hover:opacity-100 group-hover:visible invisible"
                   src="../../../src/assets/images/undo.svg"
                   @click="(e) => undo(e, each)" />
              <div :id="each?.subsection"
                   class="flex flex-row ml-3 h-3 w-24 items-center justify-between mr-3 text-main-alt opacity-40 hover:opacity-100 group-hover:visible invisible whitespace-nowrap"
                   @click="(e) => copyAll(e, each)">
                Copy to all
                <img src="../../../src/assets/images/copy.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </StandardTemplate>
</template>

<script>
import StandardTemplate from '@/components/layout/StandardTemplate';
// import settingsNav      from '@/components/layout/SettingsNav';
const UserService = require('Services/UserService');

export default {
  name: "Settings",
  components: { StandardTemplate }, // settingsNav },
  data () {
    return {
      settings: null, oldSettings: {},
      loading: true,
    };

  },
  created () {
    UserService.GetCustomNullValues()
      .then((results) => {
        const emptyValues = [
          // vitals
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Temperature" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Heart Rate" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Breathing" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Mucus Membranes" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Capillary Refill Time" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Weight" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Body Condition Score" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Pain Score" },
          // physical
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Attitude/Behavior" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Hydration" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Nose/Throat" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Eyes" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Ears" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Mouth/Teeth" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Heart/Blood Vessels" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Lungs/Airways" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Abdomen" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Gastrointestinal System" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Anal Glands" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Coat/Skin/Nails" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Lymph Nodes" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Musculoskeletal" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Central Nervous System" },
          { template_type: "SOAP", value: "Within normal limits", section: "objective", subsection: "Urinary/Genitals" },

          // ??
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Cardiovascular" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Respiratory" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Neurological" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Lymphatic" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Gastrointestinal" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Reproductive/Urinary" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Fur/Skin" },
          // { template_type: "SOAP", value: "", section: "objective", subsection: "Respiratory Rate" },
        ];
        let tmp = results.data.default_values;

        tmp = tmp
          .filter(x => x.subsection !== "")
          .filter(x => x.section !== "Objective");// temporary TODO phase 3 work with
        // get unique records
        tmp = tmp.filter((x, index) => {
          return index === tmp.findIndex(y => y.subsection == x.subsection);
        });

        for (let i = 0; i < tmp.length; i++) {
          let v = emptyValues.findIndex((val) => val.subsection == tmp[i].subsection);
          if (v !== -1) {
            // doing this value swap gives us the preferred ordering of the emptyValues set
            emptyValues[v] = tmp[i];
            tmp.splice(i, 1);
            i--;
          }
        }
        this.settings = [...emptyValues, ...tmp];
        this.oldSettings = this.settings.map(x => { return { ...x }; });
      }).finally(() => {
        this.loading = false;
      });
  },
  beforeUnmount () {
    if (this.$store.getters.isLoggedIn && !this.loading && this.settings) {
      UserService.UpdateCustomNullValues(this.settings);
    }
  },
  methods: {
    saveValue (e, field) {
      const property = field.subsection;
      if (this.oldSettings.find((each) => each.subsection == property).value == field.value) return;
      UserService.UpdateCustomNullValues([this.settings.find((each) => each.subsection == property)]);
    },
    undo (e, value) {
      const property = value.subsection;
      const oldValue = this.oldSettings.find((each) => each.subsection == property).value;
      value.value = oldValue;
      UserService.UpdateCustomNullValues([value]);
    },
    copyAll (e, value) {
      const newAll = value.value;
      this.settings.forEach(each => each.value = newAll);
      UserService.UpdateCustomNullValues(this.settings);
    },
    inputFocused (e, value) {
      const property = value.subsection;
      this.oldSettings.find((each) => each.subsection == property).value = e.target.value;
    }
  }
};


</script>

<style scoped>
input:focus-visible~div>* {
  visibility: visible;
}

h4 {
  text-transform: none;
}
</style>